/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popBitgetUidSubmit.vue?vue&type=template&id=7f958da6&scoped=true"
import script from "./popBitgetUidSubmit.vue?vue&type=script&lang=js"
export * from "./popBitgetUidSubmit.vue?vue&type=script&lang=js"
import style0 from "./popBitgetUidSubmit.vue?vue&type=style&index=0&id=7f958da6&prod&lang=scss&scoped=true"
import style1 from "./popBitgetUidSubmit.vue?vue&type=style&index=1&id=7f958da6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f958da6",
  null
  
)

export default component.exports